import { render, staticRenderFns } from "./OakHelp.vue?vue&type=template&id=7019143d"
import script from "./OakHelp.vue?vue&type=script&lang=js"
export * from "./OakHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports